/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Insurances/Insurance/InsuranceCode/Loading"
  
}) {
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 disabled={true}
 marginTop={0}
 placeholder="Loading insurance codes..."
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}